import { render, staticRenderFns } from "./ComparisonSelections.vue?vue&type=template&id=0fa01957&scoped=true"
import script from "./ComparisonSelections.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonSelections.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComparisonSelections.vue?vue&type=style&index=0&id=0fa01957&prod&lang=less&scoped=true"
import style1 from "./ComparisonSelections.vue?vue&type=style&index=1&id=0fa01957&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa01957",
  null
  
)

export default component.exports